import {RoomDataType} from '../redux/types'; // REFACTOR TYPES

export default function getNoOfRoomFlavors(rooms: Array<RoomDataType>) {
  if (!rooms || !rooms.length) {
    return 0;
  }

  let roomFlavorsCount = 0;

  rooms.forEach(room => {
    room.rpl.forEach(roomFlavor => {
      roomFlavorsCount++;
    });
  });

  return roomFlavorsCount;
}
